import { getNestedProperty } from '@opallabs/lambda'
import { BrandCollection, State, StateKeys } from '../../../../types'

export const getBrandId: (state: State) => string = (state: State) =>
  state.current_workspace_id
export const getBrands: (state: State) => BrandCollection | undefined = (
  state: State
) =>
  getNestedProperty<BrandCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.brand
  )
